import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../../report/reportActions';

import { Button } from '../../components/buttons';
import { Page, PageContent, PageHeader } from '../../components/common';
import { BirthDatePicker } from '../../components/forms';
import Utils, { SecurityRoles } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	financials: FinancialExportDto[];
}
interface State {
	fromDate: string | undefined;
	toDate: string | undefined;
}
class FinancialExportPage extends React.Component<Props, State> {
	state = {
		fromDate: undefined,
		toDate: undefined
	};

	onFilterChange = (e: any) => {
		this.setState({ [e.target.name]: e.target.value });
	}

	download = () => {
		this.props.actions.fetchFinancialExport(this.state.fromDate, this.state.toDate).then(() => {
			const formattedFinancials = this.formatData(this.props.financials);
			Utils.downloadCsv(formattedFinancials, 'FinancialExport.csv');
		});
	}
	formatData = (financials: FinancialExportDto[]) => {
		const formattedFinancials = financials.map(f => {
			return {
				UserId: f.userId,
				Name: f.name,
				HasSpouse: f.hasSpouse,
				Mortgage: Utils.formatCurrency(f.mortgage),
				OtherDebt: Utils.formatCurrency(f.otherDebt),
				BeneficiaryAmountPerYear: f.beneficiaryAmountPerYear,
				BeneficiaryAmountTotalYears: f.beneficiaryAmountTotalYears,
				SavingsAmount: Utils.formatCurrency(f.savingsAmount),
				IsSmoker: f.isSmoker,
				Age: f.age,
				PolicyNumber: f.policyNumber,
				EffectiveDate: Utils.formatDateAsUTC(f.effectiveDate),
				EndDate: Utils.formatDateAsUTC(f.endDate),
				CoverageAmount: Utils.formatCurrency(f.coverageAmount),
				Rate: Utils.formatCurrency(f.rate),
				Term: f.term,
				Status: Utils.getPickListItemDescription(f.statusId)
			};
		});

		return formattedFinancials;
	}

	render() {
		return (
			<Page title="Financial export">
				<PageContent>
					<PageHeader title="Financial export" className="page-header-sm" />
					<h2 className="form-fieldset-title">Report Filters</h2>
					<div className="form-fieldset mb-4">
						<div className="row">
							<BirthDatePicker
								className="col-sm-6 col-lg-3"
								labelText="From"
								name="fromDate"
								placeholder="YYYY-MM-DD"
								value={this.state.fromDate}
								onChange={this.onFilterChange}
								required={true}
							/>
							<BirthDatePicker
								className="col-sm-6 col-lg-3"
								labelText="To"
								name="toDate"
								placeholder="YYYY-MM-DD"
								value={this.state.toDate}
								onChange={this.onFilterChange}
								required={true}
							/>
						</div>
						<div className="row col-sm-12">
							<Button
								className="btn-primary"
								onClick={this.download}
								disabled={this.state.fromDate == null || this.state.toDate == null}
							>
								<span className="align-middle mx-2">Download</span>
							</Button>
						</div>
					</div>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		financials: state.report.financials
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(FinancialExportPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/FinancialExportPage.tsx